<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
    <template #DETAILS="{ visible, params }">
      <Details v-if="visible" :row="params"></Details>
    </template>
  </cTable>
</template>

<script>
import {
  getList,
  add,
  del,
  update,
  getDetails,
  recalculate,
  sync,
  createBill,
  confirm,
  cancelConfirm,
  deleteBill,
  append,
  getRates,
  saveRates,
  getConfig,
  getWriteOffData,
  writeOff,
  Export, ExportWanted,
} from "@/api/finance/other_fee_bill_hq";
import cTable from "@/base/common/index";
import { getCurrency } from "@/api/finance/currency";
import { getCountry } from "@/api/system/country";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getUser } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";
import Details from "./detail";
import toPage from "@/base/common/topage";
import { getBank } from "@/api/finance/bank";
import invoice from "@/components/invoice";
import ExportDetail from "@/view/finances/other_fee_bill_hq/exportDetail.vue";

export default {
  mixins: [toPage],
  name: "other_fee_bill_hq",
  components: {
    ExportDetail,
    cTable,
    Details,
    invoice
  },
  activated() {
    if (this.$store.state.user.pageUrl) {
      this.$refs["table"].$refs["header"].searchForm.keywords =
        this.$store.state.user.pageUrl;
      this.$store.state.user.pageUrl = "";
      this.$refs["table"].getList();
    }
  },
  data() {
    return {
      methods: {
        getDetails,
        del,
        add,
        update,
        list: getList,
        recalculate,
        sync,
        createBill,
        confirm,
        cancelConfirm,
        deleteBill,
        append,
        getRates,
        saveRates,
        getBank,
        getWriteOffData,
        writeOff,
        Export,
        ExportWanted
      },
      footer: {},
      config: {
        height: 630,
        contentMethod({ row, column }) {
          if (column.type == "calculate_status" && row.calculate_msg) {
            return row.calculate_msg;
          }
        },
      },
      modals: {
        writeOff: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row))
              if (!data.invoice.is_open) delete data['invoice']
              this.$page.handleRequestMethods("writeOff", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              off_type: 24,
            },
            {
              bank_id: 24,
            },
            {
              currency: 24,
            },
            {
              amount: 24,
            },
            {
              transaction_id: 24,
            },
            {
              remarks: 24,
            },
            { invoice: 24 }
          ],
          fields: [
            {
              name: () => this.$tz("是否,开票"),
              key: 'invoice',
              render(h, p) {
                if (!p.row.invoice) p.row.invoice = { is_open: 0, amount: '' }
                return h(invoice, {
                  props: {
                    formData: p.row.invoice
                  },
                })
              }
            },
            {
              name: this.$tz("核销方式"),
              key: "off_type",
              component: "Radio",
              placeholder: () => this.$tz("核销方式"),
              options: [
                { label: this.$tz("线下核销"), value: 1 },
                { label: this.$tz("线上核销"), value: 2 },
              ],
              optionsFn: "",
              optionsKey: "",
              default: 2,
              bind: {
                border: true,
              },
              methods: {
                "on-change"({ row }) {
                  row.currency = this.$modal.params.currency;
                  row.amount = this.$modal.params.amount.toString();
                },
              },
            },
            {
              name: this.$t("bank"),
              key: "bank_id",
              component: "Select",
              show: ({ row }) => row.off_type == 1,
              placeholder: () => this.$t("select") + this.$t("bank"),
              options: [],
              config: {
                label: ({ row }) => {
                  return row.account_type + "(" + row.bank_code + ")";
                },
                value: "id",
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
              },
            },
            {
              name: this.$t("check_amount"),
              key: "amount",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("check_amount"),

              disabled: ({ row }) => row.off_type == 1,
            },
            {
              name: this.$t("check_amount_currency"),
              placeholder: () =>
                this.$t("select") + this.$t("check_amount_currency"),
              key: "currency",
              component: "Select",
              disabled: ({ row }) => row.off_type == 1,
              options: [],
              optionsFn: "getCurrency",
            },

            {
              name: this.$t("transaction_id"),
              key: "transaction_id",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("transaction_id"),
              show: ({ row }) => row.off_type == 1,
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              show: ({ row }) => row.off_type == 1,
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
          ],
        },
        rate: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("saveRates", data, false, true)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$t("rate"),
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              to_bill_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              to_bill_currency: 24,
            },
          ],
          fields: [
            {
              name: this.$t("toCurrency"),
              key: "to_bill_currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code",
              },
              methods: {
                list({ field }) {
                  getCurrency().then((res) => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                },
              },
            },
          ],
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              draggable: true,
              transfer: true,
              width: 1500,
            },
            modalContentBind: {
              style: {
                height: "700px",
              },
            },
          },
          footer: {
            show: () => false,
          },
        },
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods("append", data, false, true)
                .then((res) => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg,
                  });
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              numbers: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              numbers: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("Odd_Numbers"),
              key: "numbers",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Odd_Numbers"),
              bind: {
                rows: 5,
                type: "textarea",
              },
            },
          ],
        },
        update: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods("update", data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              title: this.$t("handle"),
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bill_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {
              bill_name: 24,
            },
            {
              bill_remarks: 24,
            },
          ],
          fields: [
            {
              name: () => this.$t("bill_name"),
              key: "bill_name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("bill_name"),
            },
            {
              name: () => this.$t("Remarks"),
              key: "bill_remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 3,
                type: "textarea",
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "time_type",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [
              {
                label: this.$t("createTime"),
                value: 1,
              },
              {
                label: this.$t("check_time"),
                value: 2,
              },
            ],
            default: 1,
          },
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "date",
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("tip");
            },
            component: "Select",
            options: [
              {
                value: 1,
                label: this.$t("unconfirmed"),
              },
              {
                value: 4,
                label: this.$t("PendingWriteOff"),
              },
              {
                value: 9,
                label: this.$t("WrittenOff"),
              },
            ],
          },
          // {
          // 	key: "bill_type",
          // 	placeholder() {
          // 		return this.$t("select") + this.$t("codTypes");
          // 	},
          // 	component: "Select",
          // 	options: [],
          // },
          // {
          // 	key: "bill_status",
          // 	placeholder() {
          // 		return this.$t("select") + this.$t("bill_type");
          // 	},
          // 	component: "Select",
          // 	options: [],
          // },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          // {
          // 	key: "ownership",
          // 	placeholder() {
          // 		return this.$t("select") + this.$t("ownership");
          // 	},
          // 	component: "Select",
          // 	options: [],
          // 	config: {
          // 		label: "title",
          // 		value: "id"
          // 	}
          // },
          // {
          // 	key: "deliver",
          // 	placeholder() {
          // 		return this.$t("select") + this.$t("agentName");
          // 	},
          // 	component: "Select",
          // 	options: [],
          // 	config: {
          // 		label: "agent_name",
          // 		value: "id"
          // 	}
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("add"),
            //   type: "add",
            //   fnName: "add",
            //   bind: {
            //     icon: "md-add",
            //     type: "warning",
            //   },
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
            {
              name: () => this.$t("resAmount"),
              type: "resAmount",
              fnName: "resAmount",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("confirm"),
              type: "confirm",
              fnName: "batch",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("Cancel Confirm"),
              type: "cancelConfirm",
              fnName: "batch",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("Delete Bills"),
              type: "deleteBill",
              fnName: "batch",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rate",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                type: "warning",
              },
            },
            {
              name: () => this.$t("batch") + this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOff",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error",
              },
            },
          ],
          methods: {
            writeOff() {
              let ids = this.selectAll.map((item) => item.id);
              this.handleRequestMethods("getWriteOffData", {
                ids,
              }).then((res) => {
                res.payload.ids = ids;
                this.getModal("writeOff").open(res.payload, function () {
                  this.setTitle(this.$t("writeOff"));
                });
              });
            },
            rate() {
              let ids = this.selectAll.map((item) => item.id);
              this.handleRequestMethods("getRates", {
                ids,
              }).then((res) => {
                let modal = this.getModal("rate");

                res.payload.ids = ids;
                modal.modal.grid.splice(1);
                modal.modal.fields.splice(1);
                modal.modal.fields = modal.modal.fields.concat(
                  Object.keys(res.payload).reduce((a, b) => {
                    if (
                      b === "to_bill_currency" ||
                      b === "ids" ||
                      b === "required"
                    )
                      return a;
                    let currency = b.split("_")[0].toUpperCase();
                    a.push({
                      name: () =>
                        currency + modal.$t("Change Target Currency Rate"),
                      key: b,
                      component: "InputNumber",
                      placeholder: () =>
                        currency + modal.$t("Change Target Currency Rate"),
                      bind: {
                        min: 0,
                        step: 0.01,
                        style: "width:100%",
                      },
                      default: 0,
                    });
                    modal.modal.grid.push({ [b]: 24 });
                    console.log(a);
                    return a;
                  }, [])
                );
                console.log(modal.modal);
                modal.modal.config.rules = {};
                modal.modal.config.rules["to_bill_currency"] = [
                  {
                    required: true,
                    message: "cannot be empty",
                    trigger: "blur",
                  },
                ];
                if (res.payload.required)
                  res.payload.required.forEach((t) => {
                    modal.modal.configs.rules[t] = [
                      {
                        required: true,
                        message: "cannot be empty",
                        trigger: "blur",
                        type: "number",
                      },
                    ];
                  });
                this.getModal("rate").open(
                  Object.assign(res.payload),
                  function () {
                    this.$forceUpdate();
                  }
                );
              });
            },
            add() {
              this.getModal("add").open();
            },
            batch({ field }) {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: field.name(),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(field.type, {
                    ids: data,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            createBill({ searchForm }) {
              this.getModal("createBill").open(searchForm);
            },
            export() {
              this.exportExc();
            },
            // add() {
            // 	this.getModal("add").open(null, () => {
            // 		this.getModal("add").setTitle(this.$t("add"));
            // 		this.getModal("add").type = "add";
            // 	});
            // },
            resAmount() {
              let data = this.selectAll.map((item) => item.id);
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("resAmount"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("recalculate", {
                    ids: data,
                  }).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
            synchronousFn() {
              this.$Modal.confirm({
                title: this.$t("synchronous"),
                width: 300,
                content:
                  this.$t("whether") +
                  this.$t("confirmOrder") +
                  this.$t("synchronous") +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("sync", null, true).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          component: this.$hasPermission(402) || true ? "Button" : "span",
          minWidth: 250,
          copy: true,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            render({ row }) {
              return row.bill_number;
            },
            click({ row }) {
              if (!this.$hasPermission(402) && false) return;
              this.$page.getModal("showDetails").open(row, function () {
                this.setTitle(row.bill_number);
              });
            },
          },
        },
        {
          name: () => this.$t("b2bClient"),
          key: "client_account",
          minWidth: 130,
        },
        {
          name: () => this.$t("bill_name"),
          key: "bill_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("cod_number"),
          key: "total_votes",
          minWidth: 130,
        },
        {
          name: () => this.$t("OriginalFee"),
          children: [
            {
              name: "KWD",
              minWidth: 100,
              children: [
                {
                  name: () => this.$t("SHIPMENTS"),
                  key: "kwd_votes",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("reChAmount"),
                  key: "kwd_amount",
                  minWidth: 100,
                },
              ],
            },


            {
              name: "AED",
              minWidth: 100,
              children: [
                {
                  name: () => this.$t("SHIPMENTS"),
                  key: "aed_votes",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("reChAmount"),
                  key: "aed_amount",
                  minWidth: 100,
                },
              ],
            },

            {
              name: "QAR",
              minWidth: 100,
              children: [
                {
                  name: () => this.$t("SHIPMENTS"),
                  key: "qar_votes",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("reChAmount"),
                  key: "qar_amount",
                  minWidth: 100,
                },
              ],
            },
            {
              name: "CNY",
              minWidth: 100,
              children: [
                {
                  name: () => this.$t("SHIPMENTS"),
                  key: "cny_votes",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("reChAmount"),
                  key: "cny_amount",
                  minWidth: 100,
                },
              ],
            },
            {
              name: "SAR",
              minWidth: 100,
              children: [
                {
                  name: () => this.$t("SHIPMENTS"),
                  key: "sar_votes",
                  minWidth: 100,
                },
                {
                  name: () => this.$t("reChAmount"),
                  key: "sar_amount",
                  minWidth: 100,
                },
              ],
            },
          ],
        },
        {
          name: () => this.$t("TargetSettlementFee"),
          children: [
            {
              name: () => this.$t("toCurrency"),
              key: "to_bill_currency",
              minWidth: 100,
            },
            {
              name: () => this.$t("rate"),
              minWidth: 100,
              children: [
                {
                  name: "KWD",
                  key: "kwd_to_rate",
                  minWidth: 100,
                },
                {
                  name: "AED",
                  key: "aed_to_rate",
                  minWidth: 100,
                },
                {
                  name: "QAR",
                  key: "qar_to_rate",
                  minWidth: 100,
                },
                {
                  name: "CNY",
                  key: "cny_to_rate",
                  minWidth: 100,
                },
                {
                  name: "SAR",
                  key: "sar_to_rate",
                  minWidth: 100,
                },
              ],
            },
            {
              name: () => this.$t("TotalAmountReceivable"),
              key: "to_bill_amount",
              minWidth: 100,
            },
          ],
        },
        {
          name: () => this.$t("tip"),
          key: "bill_status_txt",
          minWidth: 130,
        },
        {
          name: () => this.$t("Remarks"),
          key: "bill_remarks",
          minWidth: 130,
        },
        {
          name: () => this.$t("createUser"),
          key: "creator_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("audit"),
          key: "confirm_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("audit_time"),
          key: "confirm_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("writeOffUser"),
          key: "off_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          minWidth: 130,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "addTo",
              fnName: "addTo",
              bind: {
                type: "success",
              },
              disabled: ({ row }) =>
                row.bill_status == 9 || row.bill_status == 4,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              disabled: ({ row }) =>
                row.bill_status == 9 || row.bill_status == 4,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "success",
              },
            },
          ],

          methods: {
            addTo({ row }) {
              this.getModal("add").setTitle(this.$t("addTo"));
              this.getModal("add").open({
                id: row.id,
              });
            },
            export({ row }) {
              this.handleRequestMethods("Export", row.id).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                window.open(this.$globalUrl + res.payload);
              });
            },
            update({ row }) {
              this.getModal("update").setTitle(this.$t("update"));
              this.getModal("update").type = "update";
              this.getModal("update").open({
                id: row.id,
                bill_name: row.bill_name,
                bill_remarks: row.bill_remarks,
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
  async mounted() {
    // let fromCountry = (await getCountry({
    // 	allow_depart: 1
    // })).data.payload.rows;
    // let toCountry = (await getCountry({
    // 	allow_arrive: 1
    // })).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    // let salesman = (await getUser({
    // 	standard: "Salesman"
    // })).data.payload.rows;
    // let companiesList = (await getCompanies()).data.payload;
    // let config = (await getConfig()).data.payload;
    // console.log('config', config);
    this.header.searchs.forEach(async (item) => {
      // 	if (item.key === "from_country") item.options = fromCountry;
      // 	if (item.key === "to_country") item.options = toCountry;
      if (item.key === "client_id") item.options = client;
      // 	if (item.key === "salesman_id") item.options = salesman;
      // 	if (item.key === "ownership") item.options = companiesList;
      // 	if (item.key === "bill_status") item.options = config.bill_status;
      // 	if (item.key === "bill_type") item.options = config.bill_type;
    });
  },
};
</script>
